import { MainLayout, DashboardLayout, Button } from "components";
import React from "react";
import { useSubscriptions } from "hooks/useSubscriptions";
import { useRouter } from "next/router";
import BillingAddressRequiredBanner from "components/dashboard/BillingAddressRequiredBanner";
import { useCustomer } from "hooks/useCustomer";
import SubscriptionUsage from "./SubscriptionUsage";
import Link from "next/link";
import { routes } from "utils/routes";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useSubscriptionAddons } from "hooks/useSubscriptionAddons";
import SubscriptionInfo from "components/dashboard/SubscriptionInfo/SubscriptionInfo";
import { usePPUBalance } from "hooks/usePPUBalance";

const SubscriptionPage = () => {
  const router = useRouter();

  const { bypassRequiredAction } = router.query;
  const { enhancedSubscription } = useSubscriptions();
  const { balance: ppuBalance } = usePPUBalance();
  const { addons } = useSubscriptionAddons();

  const { customer } = useCustomer({ migrate: true });

  if (
    // bypass not activated
    !bypassRequiredAction &&
    // not a starter plan
    enhancedSubscription?.currentPlan.name !== "STARTER" &&
    // not a trial
    enhancedSubscription?.currentPlan.isTrial === false &&
    // customer data fetched
    customer &&
    // missing address
    !customer.address
  ) {
    return (
      <MainLayout title="Action Required">
        <BillingAddressRequiredBanner />
      </MainLayout>
    );
  }

  return (
    <DashboardLayout
      title="Subscription"
      breadcrumbs={[{ href: "#", label: "Subscription", active: true }]}
      actions={
        ppuBalance?.active ? (
          <Link href={routes.ppuOrderHistory}>
            <Button
              type="submit"
              size="xs"
              variant="outline-secondary"
              uppercase
            >
              Order History
            </Button>
          </Link>
        ) : (
          <>
            <Link href={routes.ppuOrderHistory}>
              <Button
                type="submit"
                size="xs"
                variant="outline-secondary"
                uppercase
              >
                Order History
              </Button>
            </Link>
            <Link href={routes.billingPortal} style={{ marginLeft: "8px" }}>
              <Button
                type="submit"
                size="xs"
                variant="outline-secondary"
                uppercase
                icon={<FaExternalLinkAlt size={10} />}
              >
                Manage Billing
              </Button>
            </Link>
          </>
        )
      }
    >
      <div className="section">
        <SubscriptionInfo
          subscription={enhancedSubscription}
          addons={addons}
          ppu={ppuBalance}
          showPPUActions
        />
      </div>
      <div className="section">
        <SubscriptionUsage />
      </div>

      <style jsx>{`
        .section {
          display: flex;
          flex-direction: column;
          margin-bottom: 24px;
        }
      `}</style>
    </DashboardLayout>
  );
};

export default SubscriptionPage;
